import React, { ReactNode } from 'react';

interface Props<T> {
  children?: (
    values: T,
    onChange: (newValues) => void,
    idx: number,
    lines: T[],
    onChangeAll: (newValues: any[], changedValues: any[], originals?: T[]) => void,
    customActions?: { [key: string]: (e: any) => void },
  ) => ReactNode;
  lines: T[];
  onChange?: (lines: T[], changedLines: number[], originals?: T[]) => void;
}

export function MultiInput<T>({children, lines, onChange}: Props<T>): ReactNode {
  lines = lines ? lines : [];
  return (
    <>
      {lines.map((line: T, idx: number): ReactNode => {
        const onChangeLineCallback = (changedLine: any): void => {
          const org: T[] = [...lines];
          lines[idx] = changedLine;
          if (onChange) {
            onChange(lines, [idx], org);
          }
        };
        return children(line, onChangeLineCallback, idx, lines, onChange);
      })}
    </>
  );
}
